<template>
  <b-modal ref="mdlConfigurazioneMagazzinoMarcaArticoli" :title="title" centered no-close-on-backdrop no-close-on-esc hide-header-close size="lg">
    <b-row>
      <b-col cols="12" xs="12" sm="4" md="6" lg="6" xl="6">
        <label class="sa-label-data">Codice Azienda</label>
        <b-form-select v-model="localData.codiceAzienda">
          <template #first>
            <b-form-select-option :value="null" disabled>- Seleziona -</b-form-select-option>
          </template>
          <b-form-select-option v-for="item in strutturaOptions" :key="item.id" :value="item.codiceStruttura"
            ><span>{{ `${item.denominazione} (${item.codiceStruttura}) ` }}</span></b-form-select-option
          >
        </b-form-select>
      </b-col>
      <b-col cols="12" xs="12" sm="4" md="6" lg="6" xl="6">
        <label class="sa-label-data">Marca</label>
        <span v-if="isReadOnly"> {{ localData.marca }}</span>
        <b-form-input v-else v-model="localData.marca"></b-form-input>
      </b-col>
    </b-row>
    <template #modal-footer>
      <b-button v-if="!isReadOnly" size="md" variant="outline-danger" @click="onCloseModal">Annulla</b-button>
      <b-button v-if="!isReadOnly" size="md" variant="outline-success" @click="onClickSalvaMarcaArticolo">Salva</b-button>
      <b-button v-if="isReadOnly" size="md" variant="outline-secondary" @click="onCloseModal">Chiudi</b-button>
    </template>
    <modal-error ref="cmpModalError"></modal-error>
  </b-modal>
</template>
<script>
import ModalError from "../../../template/components/modal/components/ModalError.vue";
import StruttureMixin from "../../strutture/mixins/StruttureMixin";
import UtilityMixin from "../../utility/UtilityMixin";
import MagazzinoMixins from "../mixins/MagazzinoMixins";
export default {
  mixins: [UtilityMixin, StruttureMixin, MagazzinoMixins],
  components: { ModalError },
  data() {
    return {
      title: null,
      pathResource: "/magazzinoarticolimarche",
      isReadOnly: false,
      localData: {
        id: null,
        codiceAzienda: null,
        marca: null,
      },
    };
  },
  props: {
    jsonData: {
      type: Object,
      default: () => {
        return null;
      },
    },
  },
  mounted() {
    this.struttureLoadData();
  },
  methods: {
    show(jsonData, isReadOnly) {
      let me = this;
      me.localData = jsonData;
      me.isReadOnly = isReadOnly;
      if (me.jsonData) {
        this.localData.codiceAzienda = me.jsonData.codiceAzienda;
      }
      if (isReadOnly) {
        me.title = "Visualizzazione Marca";
      } else {
        me.title = !jsonData.id ? "Nuova Marca" : "Aggiorna Marca";
      }

      me.$refs.mdlConfigurazioneMagazzinoMarcaArticoli.show();
    },
    onCloseModal() {
      let me = this;
      me.localData = {
        id: null,
        codiceAzienda: null,
        marca: null,
      };
      me.$emit("onCloseModal");
      me.$refs.mdlConfigurazioneMagazzinoMarcaArticoli.hide();
    },
    onClickSalvaMarcaArticolo() {
      let me = this;
      UtilityMixin.methods.saveResource(me.pathResource, me.localData, me.salvaMarcaArticoloSuccess, me.salvaMarcaArticoloError);
    },
    salvaMarcaArticoloSuccess(response) {
      let me = this;
      me.$emit("saveMarcaArticolo", response);
      me.$refs.mdlConfigurazioneMagazzinoMarcaArticoli.hide();
      me.$bvToast.toast("Salvataggio avvenuto con successo", {
        title: "Successo",
        variant: "success",
        solid: true,
      });
    },
    salvaMarcaArticoloError(error) {
      let me = this;
      me.$emit("saveMarcaArticolo", error);
      me.$refs.cmpModalError.show(error.response.data.messaggio);
    },
    onDeleteMarcaArticolo(item) {
      let me = this;
      me.$bvModal
        .msgBoxConfirm("Sei sicuro di eliminare questa configurazione?", {
          title: "Eliminazione Marca",
          buttonSize: "sm",
          okTitle: "SI",
          cancelTitle: "NO",
          okVariant: "danger",
          cancelVariant: "secondary",
          hideHeaderClose: true,
          footerClass: "p-2",
          centered: true,
        })
        .then((value) => {
          if (value) {
            me.deleteMarcaArticolo(item.id);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    deleteMarcaArticolo(id) {
      let me = this;
      UtilityMixin.methods.deleteResource(me.pathResource + "/" + id, null, me.deleteMarcaArticoloSuccess, me.deleteMarcaArticoloError);
    },
    deleteMarcaArticoloSuccess(response) {
      let me = this;
      me.$emit("marcaArticoloDelete", response);
      me.$bvToast.toast("Eliminazione avvenuta con successo", {
        title: "Successo",
        variant: "success",
        solid: true,
      });
    },
    deleteMarcaArticoloError(response) {
      let me = this;
      me.$emit("marcaArticoloDelete", response);
      me.$bvToast.toast("Errore durante l'eliminazione", {
        title: "Errore",
        variant: "danger",
        solid: true,
      });
    },
  },
};
</script>
